import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import "./pessoasOrdemCadastro.css";
import Header from "../../components/header/header";
import CustomModal from "../../components/modal/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import {
  getManutentorById,
  getManutentorCadastro,
  getManutentorUpdate,
} from "../../services/api_cadastro_pessoas_ordem";
import { getPessoas } from "../../services/api_pessoas";
import Swal from "sweetalert2";
import Spinner from "react-bootstrap/Spinner";
import { getPessoasSetoresExecutantes } from "../../services/api_pessoas_setores_executantes";
import POLLING_INTERVAL from "../../hooks/Interval/interval";

const PessoasOrdemRegister = (props) => {
  //console.log(props);
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state?.id;
  const idServicoOrdem = location.state?.idServicoOrdem;
  const idSetorExecutante = location.state?.idSetorExecutante;
  const [id_pessoa, setPessoa] = useState("");
  const [data_hora_inicio, setDataHoraInicio] = useState("");
  const [data_hora_fim, setDataHoraFim] = useState("");
  const [manutentor, setManutentor] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [isSaving, setSaving] = useState(false)
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});
  //console.log("idServico: ", idServicoOrdem);
  //console.log("idSetor: ", idSetorExecutante);

  const inputRefs = {
    Manutentor: useRef(null),
    dataHoraInicio: useRef(null),
    dataHoraTermino: useRef(null),
  };

  useEffect(() => {
    const fetchPessoasOrdem = async () => {
      try {
        const response = await getManutentorById(id);
        //console.log("informações id pessoas ordem", response);
        const manutentor = response.data.PessoaServicoOrdem;
        if (manutentor) {
          setPessoa(manutentor.id_pessoa || "");
          setDataHoraInicio(manutentor.data_hora_inicio || "");
          setDataHoraFim(manutentor.data_hora_fim || "");
        } else {
          console.error("Dados não encontrados:", response);
        }
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }
    };

    if (id) {
      fetchPessoasOrdem();
    }
  }, [id]);

  useEffect(() => {
    const fetchPessoas = async () => {
      let arrayIdsPessoas = [];

      try {
        let response = await getPessoasSetoresExecutantes(); //Pegando todos os registros de pessoas_setores_executantes

        if (response.status === 200) {
          //Filtrando registros, de modo que restem apenas os registros que tenham o campo id_setor_executante igual ao setor executante do serviço da ordem de serviço
          const arrayPessoasSetoresFiltrado =
            response.data.PessoasSetoresExecutantes.filter(
              (item) => item.id_setor_executante === idSetorExecutante
            );

          //Alimentando array com os IDs das pessoas que pertencem ao setor executante especificado no serviço da ordem de serviço
          arrayIdsPessoas = arrayPessoasSetoresFiltrado.map(
            (item) => item.id_pessoa
          );
        }

        response = await getPessoas();
        if (response.status === 200) {
          //Setando pessoasFiltradas apenas com os registros de pessoas que tenham o seu ID incluso em arrayIdsPessoas
          const pessoasFiltradas = response.data.pessoas.filter((pessoa) =>
            arrayIdsPessoas.includes(pessoa.id)
          );
          setManutentor(pessoasFiltradas);
          setLoading(false);
        } else {
          console.error("Algo deu errado:");
        }
        //console.log(response);
      } catch (error) {
        console.error("Erro ao obter empresas:", error);
      }
    };

    fetchPessoas();
    const interval = setInterval(()=>{
      fetchPessoas()
    }, POLLING_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenModal = (title, body) => {
    setModalContent({ title, body });
    setShowModal(true);
  };

  const validarInputs = () => {
    if (!id_pessoa || !data_hora_inicio || !data_hora_fim) {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "O preenchimento de todos os campos é obrigatório.",
      });
      return false;
    }

    if (data_hora_inicio >= data_hora_fim) {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "A data e a hora de início do serviço deve ser menor que a data e a hora de fim do serviço.",
      });
      return false;
    }
    return true;
  };

  const addCadastro = async (body) => {
    try {
      const response = await getManutentorCadastro(body);

      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao cadastrar registro de manutenção:", response);
      }
    } catch (error) {
      console.error("Erro ao cadastrar registro de manutenção:", error);
    }finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const newUpdate = async (body) => {
    try {
      const response = await getManutentorUpdate(id, body);

      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao cadastrar unidade:", response);
      }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        handleOpenModal(
          "Erro de validação",
          "Houve um erro na validação dos dados."
        );
      } else if (error.response && error.response.status === 500) {
        handleOpenModal(
          "Erro interno do servidor",
          "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde."
        );
      } else {
        console.error("Erro ao atualizar dados:", error);
        handleOpenModal(
          "Erro ao atualizar a empresa",
          "Por favor, tente novamente mais tarde."
        ); // Exibir mensagem genérica de erro
      }
    }finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const handleSalvar = () => {
    if (validarInputs()) {
      setSaving(true)
      let body = {
        id_pessoa,
        id_servico_ordem: idServicoOrdem,
        data_hora_inicio,
        data_hora_fim,
      };
      if (id) {
        newUpdate(body);
      } else {
        addCadastro(body);
      }
    }
  };

  // Função para formatar a data e hora no formato AAAA/MM/DD --:--
  const handleDataHora = (e) => {
    return e.replace(/T/g, " ") + ":00";
  };

  const handleKeyDown = (e, nextFieldRef) => {
    if (e.key === 'Enter' && nextFieldRef.current) {
      e.preventDefault();
      const elementToFocus = nextFieldRef.current.inputRef || nextFieldRef.current;
  
      if (typeof elementToFocus.focus === 'function') {
        elementToFocus.focus();
      } else {
        console.warn('O elemento de input não tem o método focus.');
      }
    }
  };

  const regret = () => {
    window.history.back();
  };

  return (
    <>
      <Header title="/ Cadastro de Pessoas em Servicos da Ordem" />
      <div className="content-wrapper pl-5 pr-5 pt-2">
        {isLoading ? (
          <div className="center-btn">
            <h5 className="mb-5">Carregando dados</h5>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <Form>
            <Row>
              <Col md={4} className="mb-3">
                <Form.Group controlId="form">
                  <Form.Label>Manutentor</Form.Label>
                  <Form.Control
                    as="select"
                    value={id_pessoa}
                    onChange={(e) => setPessoa(e.target.value)}
                    ref={inputRefs.Manutentor}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.dataHoraInicio)}
                  >
                    <option value="">Selecione</option>
                    {manutentor &&
                      manutentor.map((id_pessoa) => (
                        <option key={id_pessoa.id} value={id_pessoa.id}>
                          {id_pessoa.nome}
                        </option>
                      ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Group controlId="form">
                  <Form.Label>Data e Hora de Início</Form.Label>
                  <Form.Control
                    type="datetime-local"
                    value={data_hora_inicio}
                    /*onChange={(e) => setDataHoraInicio(e.target.value) }*/
                    onChange={(e) =>
                      setDataHoraInicio(handleDataHora(e.target.value))
                    }
                    ref={inputRefs.dataHoraInicio}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.dataHoraTermino)}
                  />
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Group controlId="form">
                  <Form.Label>Data e Hora de Fim</Form.Label>
                  <Form.Control
                    type="datetime-local"
                    value={data_hora_fim}
                    onChange={(e) =>
                      setDataHoraFim(handleDataHora(e.target.value))
                    }
                    ref={inputRefs.dataHoraTermino}
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="center-two-btn d-flex justify-content-center ">
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={handleSalvar}
                disabled = {isSaving}
              >
                {isSaving ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <FontAwesomeIcon icon={faSave} />
                )}
              </Button>
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={regret}
              >
                <FontAwesomeIcon icon={faWindowClose} />
              </Button>
            </div>
          </Form>
        )}
      </div>

      <CustomModal
        show={showModal}
        handleClose={handleCloseModal}
        title={modalContent.title}
        body={modalContent.body}
      />
    </>
  );
};

export default PessoasOrdemRegister;
